import React from 'react'
import BuilderBottomModal from '../../../../ui/molecules/BuilderBottomModal'
import { TouchableOpacity, View, StyleSheet } from 'react-native'
import { WhitePlus } from '../../../../assets/icons'

import { BtText } from '@linqpal/components/src/ui'
import { useTranslation } from 'react-i18next'
import { ProjectsTable } from './ProjectTable'

interface SelectProjectModalProps {
  onAddNewProject: () => void
  onProjectSelected: (project: any | null) => void
  onClose: () => void
  isProjectForLinkingMandatory?: boolean
}

export const SelectProjectModal: React.FC<SelectProjectModalProps> = ({
  onAddNewProject,
  onProjectSelected,
  onClose,
}) => {
  const { t } = useTranslation('global')

  return (
    <BuilderBottomModal
      visible={true}
      onClose={onClose}
      height={'100%'}
      width={662}
      testID={'select-project-modal'}
    >
      <BtText
        style={styles.title}
        testID={'select-project-title'}
      >{`Add or select a project for this invoice to continue your trade credit request.`}</BtText>

      <BtText
        style={styles.subtitle}
        testID={'select-project-subtitle'}
      >{`To request trade credit for this invoice, project details are required. Select or add project details pertaining to this purchase.`}</BtText>

      <TouchableOpacity
        style={styles.addProjectBtnWithProjects}
        activeOpacity={0.8}
        onPress={onAddNewProject}
        testID="projects-add-button"
      >
        <BtText
          style={styles.addButtonLabel}
          testID={'project-modal-add-new-project-title'}
        >
          {t('Projects.add_new_project')}
        </BtText>
        <WhitePlus width={16} height={16} />
      </TouchableOpacity>
      <View style={{ marginTop: 30 }} testID={'projects-table-container'}>
        <ProjectsTable onProjectSelect={onProjectSelected} />
      </View>
    </BuilderBottomModal>
  )
}

const styles = StyleSheet.create({
  mainWrapperWithProjects: {
    flex: 1,
    width: 680,
    alignSelf: 'center',
    marginTop: 30,
  },
  mainWrapperWithoutProjects: { flex: 1 },
  title: {
    color: '#003353',
    fontSize: 24,
    fontWeight: '700',
    lineHeight: 32,
    marginBottom: 16,
  },
  subtitle: {
    color: '#003353',
    fontSize: 14,
    fontWeight: '500',
    lineHeight: 24,
  },
  addProjectBtnWithoutProjects: {
    border: 'none',
    borderRadius: 4,
    backgroundColor: '#00A0F3',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingVertical: 16,
    maxWidth: 220,
    maxHeight: 48,
    position: 'absolute',
    right: 36,
    top: 12,
  },
  addProjectBtnWithProjects: {
    border: 'none',
    borderRadius: 4,
    backgroundColor: '#00A0F3',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingVertical: 16,
    maxWidth: 220,
    maxHeight: 48,
    marginTop: 15,
  },
  addButtonLabel: {
    color: '#FFF',
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 24,
    marginRight: 24,
  },
  loadingIndicator: {
    marginTop: 300,
  },
})
